import { createSlice } from '@reduxjs/toolkit';
import axios from '../../utils/axios';
import { dispatch } from '../store';

const initialState = {
  isLoading: false,
  error: null,
  genre: [],
};

const slice = createSlice({
  name: 'genre',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET genre
    getgenreSuccess(state, action) {
      state.isLoading = false;
      state.genre = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getgenres() {
  return async () => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get('genres');
      dispatch(slice.actions.getgenreSuccess(response?.data?.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------
